import StoredLayout from '../../layouts/StoredLayout'
import Geographic from './Geographic'
export default StoredLayout(Geographic)
